import { render, staticRenderFns } from "./Telas-users.vue?vue&type=template&id=3316e9b1"
import script from "./Telas-users.vue?vue&type=script&lang=js"
export * from "./Telas-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports